import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseService from "../../services/caseService";

const useCaseActivities = (caseId: number) =>
  useQuery(
    [queryKeys.caseActivities, caseId],
    () => caseService.fetchCaseActivities(caseId),
    {
      enabled: !!caseId,
    }
  );

export default useCaseActivities;
